import { UnderMaintenance } from '@/components/ui';

export const ReportPurchasePayment = () => {
    return <UnderMaintenance />;
};

ReportPurchasePayment.displayName = 'ReportPurchasePayment';
